export default __webpack_public_path__ + "static/media/liveDataIcon.9f511a71.svg";